// import { CircularProgress } from "@mui/material";

export default function Loading() {
	return (
	  <div style={{ display: "flex", alignItems: "center" }}>
		{/* <CircularProgress style={{ color: getComputedStyle(document.body).getPropertyValue('--text'), marginRight: "1.5rem" }} size="1.5rem" />
		<h3>Loading...</h3> */}
	  </div>
	);
}